import Settings from '../config.js';

const key = 'colibri-libri-dashboard:auth:access_token';

var Auth = {
  getToken() {
    return window.localStorage.getItem(key);
  },

  setToken(token) {
    window.localStorage.setItem(key, token ? token : '');
  }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/services/Auth.js